import React from 'react';
import { Flex, Segmented } from 'antd';
import { Sun, Moon, Desktop } from '@phosphor-icons/react';
import { useThemeContext } from '../../contexts/theme-context/useThemeContext';
import { ThemeMode } from '../../styles/theme/theme.types';
import styled from 'styled-components';

interface ThemeToggleProps {
  showLabel?: boolean;
}

const StyledSegmented = styled(Segmented)`
  background: ${({ theme }) => theme.colors.backgroundSecondary};

  .ant-segmented-item-selected {
    background: ${({ theme }) => theme.colors.primary} !important;
    color: white !important;
  }

  .ant-segmented-item-label {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
  }
`;

const Label = styled.span`
  color: ${({ theme }) => theme.colors.text};
`;

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ showLabel = true }) => {
  const { themeMode, setThemeMode } = useThemeContext();

  const options = [
    {
      label: <Sun size={18} weight="bold" />,
      value: 'light' as ThemeMode,
      title: 'Jasny',
    },
    {
      label: <Desktop size={18} weight="bold" />,
      value: 'system' as ThemeMode,
      title: 'Systemowy',
    },
    {
      label: <Moon size={18} weight="bold" />,
      value: 'dark' as ThemeMode,
      title: 'Ciemny',
    },
  ];

  return (
    <Flex align="center" gap={12}>
      {showLabel && <Label>Motyw:</Label>}
      <StyledSegmented
        options={options}
        value={themeMode}
        onChange={(value) => setThemeMode(value as ThemeMode)}
      />
    </Flex>
  );
};
